import { render, staticRenderFns } from "./ModalLista.vue?vue&type=template&id=8c3434c4&scoped=true"
import script from "./ModalLista.vue?vue&type=script&lang=js"
export * from "./ModalLista.vue?vue&type=script&lang=js"
import style0 from "./ModalLista.vue?vue&type=style&index=0&id=8c3434c4&prod&lang=css"
import style1 from "./ModalLista.vue?vue&type=style&index=1&id=8c3434c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3434c4",
  null
  
)

export default component.exports